// extracted by mini-css-extract-plugin
module.exports = {"page":"OrderMailsPage_page__VCsGL","tabs":"OrderMailsPage_tabs__slx8A"};